import React from "react";
import { ApplicationOfTheCertificate } from "./components/applicationOfTheCertificate";
import { Certificate } from "./components/certificate";
import { CertificateBenefits } from "./components/certificateBenefits";
import { TypesOfTransactions } from "./components/typesOfTransactions";
import { FooterOrange } from "../../common/FooterOrange/FooterOrange";


// import styles from "./style.module.css";


export const Certification = () => {
  return (
    <>
    <Certificate/>
    <ApplicationOfTheCertificate/>
    <CertificateBenefits/>
    <TypesOfTransactions/>
    <FooterOrange
        text={"معاملات گواهی سپرده از طریق سامانه معاملاتی اسمارت ممکن است"}
        btn={"#ff5f00"}
        color={"white"}
        href={"https://smartpro.mobinsb.ir/"}
      />
    </>
  );
};
